"use client";

import React from "react";
import { Loader } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
function InquiryFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center p-12 text-center bg-card border border-border rounded-lg shadow-lg backdrop-blur-sm">
        <h3 className="font-default text-2xl text-primary mb-4">Story Received!</h3>
        <p className="text-foreground mb-8 font-default">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="tracking-wide rounded-lg border-primary text-primary hover:bg-primary/5">
          SHARE ANOTHER STORY
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="name" rules={{
        required: "Your name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-default">Owner Name</FormLabel>
              <FormControl>
                <Input placeholder="Jane Smith" className="rounded-lg bg-white/50 border-border focus:ring-ring" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="pet_name" rules={{
        required: "Pet's name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-default">Pet's Name</FormLabel>
              <FormControl>
                <Input placeholder="Luna" className="rounded-lg bg-white/50 border-border focus:ring-ring" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="email" rules={{
        required: "Email address is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-default">Email Address</FormLabel>
              <FormControl>
                <Input type="email" placeholder="jane@citypetcare.com" className="rounded-lg bg-white/50 border-border focus:ring-ring" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="photo" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground font-default">Pet Photo <span className="text-muted-foreground font-normal">(Optional)</span></FormLabel>
              <FormControl>
                <Input type="file" className="rounded-lg bg-white/50 border-border focus:ring-ring cursor-pointer" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="message" rules={{
      required: "A story is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-foreground font-default">Your Pet's Story</FormLabel>
            <FormControl>
              <Textarea placeholder="Tell us about your pet's personality, their favorite treats, or a special memory you share." className="min-h-[150px] rounded-lg bg-white/50 border-border focus:ring-ring resize-y" {...field} />
            </FormControl>
            <FormDescription className="font-default">
              We love hearing about the unique bonds between our patients and their families.
            </FormDescription>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-lg">
          <p className="text-destructive text-sm text-center font-default">{submitError}</p>
        </div>}

      <div className="flex justify-center pt-6">
        <Button type="submit" disabled={isSubmitting} size="lg" className="tracking-normal rounded-lg px-10 bg-gradient-to-br from-primary to-primary/80 hover:shadow-lg transition-all duration-300 font-default">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              SUBMITTING...
            </> : "SHARE STORY"}
        </Button>
      </div>
    </Form>;
}
export default function ShareYourPetSStory() {
  return <section data-section-id="222546" id="share-your-pets-story" className="bg-background py-24 px-4 md:px-8 relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/paw_pattern.png)',
      backgroundSize: '100px'
    }}></div>
      
      <div className="max-w-[800px] mx-auto relative z-10">
        <div className="text-center mb-12">
          <h2 className="font-default text-4xl md:text-5xl text-foreground font-bold tracking-tight">
            Want your pet featured?
          </h2>
          <p className="mt-4 text-muted-foreground font-default text-lg">
            Share your favorite moments with us and join our community gallery.
          </p>
        </div>

        <div className="bg-card p-8 md:p-12 rounded-3xl shadow-xl border border-white/20 backdrop-blur-md">
          <FormProvider formKey="story_form_patient_gallery" formId="story_form_patient_gallery" sectionName="share-your-pets-story" defaultValues={{
          name: "",
          pet_name: "",
          email: "",
          photo: "",
          message: ""
        }} validationRules={{
          name: {
            required: true
          },
          pet_name: {
            required: true
          },
          email: {
            required: true,
            pattern: "email"
          },
          message: {
            required: true
          }
        }} submitText="SHARE STORY" successMessage="Thank you for sharing! We can't wait to read your pet's story and feature them in our gallery." errorMessage="Something went wrong. Please try sharing your story again.">
            <InquiryFormInner />
          </FormProvider>
        </div>
      </div>
    </section>;
}